import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import "../../styles/Login.css";
import logo from "../../assets/colored-logo.png";
import { completePasswordReset } from "../../lib/api";

export default function SetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!token) {
      toast.error("This password link is incomplete. Request a new link.");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("The passwords do not match");
      return;
    }
    try {
      setSaving(true);
      const result = await completePasswordReset(token, password);
      toast.success(result?.message || "Password set successfully");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.message || "Unable to set the password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-logo"><img src={logo} alt="Hindsight Sustainability" /></div>
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Choose your password</h1>
        <p className="subtitle">Set a secure password to finish activating your Hindsight One account.</p>
        <div className="password-field">
          <input type={showPassword ? "text" : "password"} placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={10} required />
          <button type="button" className="password-toggle" onClick={() => setShowPassword((value) => !value)}>{showPassword ? "Hide" : "Show"}</button>
        </div>
        <input type={showPassword ? "text" : "password"} placeholder="Confirm new password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} minLength={10} required />
        <button type="submit" className="btn-primary" disabled={saving || !token}>{saving ? "Saving..." : "Set password"}</button>
        <Link className="login-link-button" to="/login">Return to sign in</Link>
      </form>
    </div>
  );
}
